import { channelClient, RequestPolicies, RequestPolicy } from 'shared/channels';
import { serviceWorkerConfigContract } from './serviceWorkerConfigContract';
import type { ServiceWorkerConfigInput } from './serviceWorkerConfigModel';

/** Writing the same config twice changes nothing, so a stopped worker may get it again. */
const CONFIG_WRITE_POLICY: RequestPolicy = { ...RequestPolicies.mutation, retryAfterTimeout: true };

/** The worker's config as the page sets it. */
export const serviceWorkerConfigClient = {
  /** Resolves once the worker stored the config. */
  set(input: ServiceWorkerConfigInput): Promise<void> {
    return channelClient.request(serviceWorkerConfigContract, 'set', input, CONFIG_WRITE_POLICY);
  },

  /** Resolves once the worker took the change; never resent, as it downloads the project data again. */
  changeLanguage(): Promise<void> {
    return channelClient.request(serviceWorkerConfigContract, 'changeLanguage', undefined, RequestPolicies.mutation);
  },
};
